import type { ReactNode } from 'react';

import { Card, getCardInfo } from '../../../../../game/card/card';

import styles from './BlackjackCardTableResult.module.css';

export function BlackjackCardTableResult({ cards }: { cards: string[] }): ReactNode {
  if (!cards || !Array.isArray(cards) || !cards.length) {
    return null;
  }

  return cards.map((card: string, index: number) => {
    const info = getCardInfo(parseInt(card?.match(/\d+/)?.[0] || '0'));
    return (
      <div className={styles.card} key={index}>
        <Card key={index} mini value={info.value} suite={info.suite} />
      </div>
    );
  });
}
